import { FieldPathByValue, FieldValues as FieldValues$, useController, UseControllerProps } from "react-hook-form";
import { NumericFormatProps } from "react-number-format";
import TextField, { TextFieldProps } from "@/components/TextField";
import { NumericFormat } from "react-number-format";

export type StringFieldName<FieldValues extends FieldValues$> = FieldPathByValue<FieldValues, string>;

export type Props<FieldValues extends FieldValues$, Name extends StringFieldName<FieldValues>> = UseControllerProps<
  FieldValues,
  Name
> &
  TextFieldProps &
  NumericFormatProps;

export default function ControlledTextField<
  FieldValues extends FieldValues$,
  Name extends StringFieldName<FieldValues>
>({ name, rules, control, required, disabled, ...props }: Props<FieldValues, Name>) {
  const {
    field,
    formState: { isSubmitting },
    fieldState: { error }
  } = useController({ name, rules: { required: !!required, ...rules }, control });
  return (
    <NumericFormat
      allowNegative={false}
      customInput={TextField as any}
      error={!!error}
      errorText={error?.message}
      required={required}
      disabled={isSubmitting || disabled}
      {...field}
      {...props}
    />
  );
}
